import React, { useState, useRef, useEffect } from "react";

import {
  IntroSection,
  AboutSection,
  AchievementsSection,
  ExperiencesSection,
  ProjectsSection,
  ContactsSection,
} from "./sections";
import { Navbar, Footer } from "components";
import LoadingScreen from "../LoadingScreen";
import { K_COLORS_DARK_NAVY } from "constants.js";

const MainPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const introRef = useRef(null);
  const aboutRef = useRef(null);
  const experienceRef = useRef(null);
  const achievementRef = useRef(null);
  const projectsRef = useRef(null);
  const contactsRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      setIsLoaded(true);
    }, 1250);
  }, []);

  const navItems = [
    { label: "ABOUT", anchorRef: aboutRef },
    { label: "EXPERIENCES", anchorRef: experienceRef },
    { label: "ACHIEVEMENTS", anchorRef: achievementRef },
    { label: "PROJECTS", anchorRef: projectsRef },
    { label: "CONTACTS", anchorRef: contactsRef },
  ];

  const loadingScreenStyle = isLoaded
    ? { zIndex: 0, opacity: 0, overflow: "auto" }
    : { zIndex: 5, opacity: 1, overflow: "hidden" };

  return (
    <>
      <LoadingScreen
        style={{ ...styles.loadingScreen, ...loadingScreenStyle }}
      />
      <div style={styles.pageScreen}>
        <Navbar
          navName="Jonathanjojo"
          navItems={navItems}
          landingRef={introRef}
        />
        <div>
          <IntroSection
            anchorRef={introRef}
            additionalData={{ nextContentRef: aboutRef }}
          />
          <AboutSection anchorRef={aboutRef} />
          <ExperiencesSection anchorRef={experienceRef} />
          <AchievementsSection anchorRef={achievementRef} />
          <ProjectsSection anchorRef={projectsRef} />
          <ContactsSection anchorRef={contactsRef} />
        </div>
        <Footer author="Jonathanjojo" year={2019} />
      </div>
    </>
  );
};

const styles = {
  loadingScreen: {
    transition: "1s",
    position: "fixed",
    top: 0,
  },
  pageScreen: {
    position: "absolute",
    top: 0,
    backgroundColor: K_COLORS_DARK_NAVY,
  },
};

export default MainPage;
